namespace advisorop.components.widgets {
    export class MeetingHubButtonController {
        $router;
        servicer: boolean;
        investor: boolean;
        advisorId: number;
        householdId: number;
        componentReady: boolean = false;
        meetingHubReady: boolean = false;
        needToLinkMessage: string = "Please link AdvisorOp to your Outlook account prior to launching MeetingHub."
        invokeMeetingHubPopupOptions: DevExpress.ui.dxPopupOptions;
        showInvokeMeetingHubPopup: boolean = false;
        showInvokeMeetingHubPopupTitle: string = "Message";

        //static $inject = ["$window"];
        constructor(private $window: any, private advisorService: services.AdvisorService) {
            this.invokeMeetingHubPopupOptions = {
                deferRendering: false,
                width: 400,
                height: 180,
                contentTemplate: "attachIMHPopup",
                showTitle: true,
                dragEnabled: false,
                closeOnOutsideClick: false,
                bindingOptions: {
                    visible: "vm.showInvokeMeetingHubPopup",
                    title: "vm.showInvokeMeetingHubPopupTitle"
                },
                toolbarItems: [
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Link to my Outlook account",
                            onClick: () => {
                                this.linkToOutlook();
                            },
                        }
                    },
                    {
                        widget: "dxButton",
                        location: "center",
                        toolbar: "bottom",
                        options: {
                            text: "Close",
                            onClick: () => {
                                this.closeInvokeMeetingHubPopup();
                            },
                        }
                    }
                ]
            };
        }

        closeInvokeMeetingHubPopup() {
            this.showInvokeMeetingHubPopup = false;
        }

        linkToOutlook() {
            this.closeInvokeMeetingHubPopup();
            this.$router.navigate(["AdvisorMsgraphIntegrationRequest"]);
        }

        onOpenMeetingHub() {
            if (!this.meetingHubReady) {
                if (!this.showInvokeMeetingHubPopup)
                    this.showInvokeMeetingHubPopup = true;

                return;
            }
            var meetingHubWindowName = "MeetingHub";

            //var type = "";
            //if (this.servicer) {
            //    type = "servicer";
            //} else if (this.investor) {
            //    type = "investor"
            //}

            //var form = document.createElement("form");
            //form.setAttribute("method", "post");
            //form.setAttribute("action", "/meetinghub/");
            //form.setAttribute("target", meetingHubWindowName);

            //var input = document.createElement("input");
            //input.type = 'hidden';
            //input.name = 'type';
            //input.value = type;
            //form.appendChild(input);

            //document.body.appendChild(form);
            // 
            this.$window.open("/meetinghub/", meetingHubWindowName, "width=1075,height=900,menubar=no");

            //form.submit();

            //document.body.removeChild(form);

            return;
        }

        $onInit(): void {
            this.advisorService.msGraphIntegrationCheck()
                .then(data => {
                    this.meetingHubReady = (data.data == "ALREADY_LINKED");
                    this.componentReady = true;
                })
                .catch(err => {
                    console.log("ERROR: ", err);
                    toastr.error("Error, please contact AdvisorOp Support");
                });
        }

    }

    class MeetingHubButton implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                $router: "<",
                servicer: "<",
                investor: "<",
                advisorId: "<",
                householdId: "<",

            };
            this.controller = ["$window", "advisorService", MeetingHubButtonController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/shared/common/meeting-hub-button.html`;
        }
    }
    angular.module(Constants.APP).component(`meetingHubButton`, new MeetingHubButton());
}